import React, { useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { AccountBalance, Business, Place } from "@mui/icons-material";
import BusinessSection from "./BusinessSection";
import AccountSection from "./AccountSection";
import LocationSection from "./LocationSection";

type Section = "businesses" | "accounts" | "locations";

const LocationsAdminManager: React.FC = () => {
  const [section, setSection] = useState<Section>("businesses");

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      {/* Section header */}
      <Box
        sx={{
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #e0e0e0",
          pb: 2,
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight={600}>
            Standorte-Verwaltung
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Firmen, Mandanten und Standorte verwalten
          </Typography>
        </Box>

        <ToggleButtonGroup
          value={section}
          exclusive
          onChange={(_, v) => v && setSection(v)}
          size="small"
          color="primary"
        >
          <ToggleButton value="businesses" sx={{ gap: 1 }}>
            <Business fontSize="small" /> Firmen
          </ToggleButton>
          <ToggleButton value="accounts" sx={{ gap: 1 }}>
            <AccountBalance fontSize="small" /> Mandanten
          </ToggleButton>
          <ToggleButton value="locations" sx={{ gap: 1 }}>
            <Place fontSize="small" /> Standorte
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Section content */}
      {section === "businesses" && <BusinessSection />}
      {section === "accounts" && <AccountSection />}
      {section === "locations" && <LocationSection />}
    </Box>
  );
};

export default LocationsAdminManager;
